// Styles
import './password.css'

// Imports
import { Box, Flex, Text, Image, Button } from '@chakra-ui/react'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Amipass from '../../assets/images/amipass.png'
import BG from '../../assets/images/onboarding.jpg'
import React, { useState } from 'react'

// Steps
import { StepFinal } from './steps/StepFinal'
import { StepOne } from './steps/StepOne'
import { StepTwo } from './steps/StepTwo'

export function Password() {
  const [steps] = useState([0, 1, 2])
  const [step, setStep] = useState(0)
  const [success, setSuccess] = useState()

  const [form, setForm] = useState({
    one: {
      code: '',
    },
    two: {
      password: '',
      rpassword: '',
    },
  })

  const handlerPreviewStep = () => {
    setStep((old) => {
      const next = old - 1
      if (next < 0) {
        return 0
      }
      return next
    })
  }

  const completeForm = (key, value) => {
    setForm((old) => ({
      ...old,
      [key]: value,
    }))
  }

  const nextStep = () => {
    setStep((old) => {
      const next = old + 1
      if (next === steps.length) {
        return 0
      }
      return next
    })
  }

  const handlerNextStep = (key, values) => {
    completeForm(key, values)
    nextStep()
  }

  const handlerNextFinal = (key, values, status) => {
    setSuccess(status)
    handlerNextStep(key, values)
  }

  const renderStep = () => {
    switch (step) {
      case 0:
        return <StepOne step={form.one} onNextStep={handlerNextStep} />
      case 1:
        return <StepTwo step={form.two} onNextStepFinal={handlerNextFinal} />
      case 2:
        return (
          <StepFinal success={success} values={{ email: form.one.correo }} />
        )
      default:
        return <StepOne onNextStep={handlerNextStep} />
    }
  }

  return (
    <Flex
      height={'100%'}
      overflowY={{ base: 'auto', sm: 'auto', md: 'nome' }}
      flexDirection={{ base: 'column', sm: 'column', md: 'row' }}
    >
      <Flex
        flex={1}
        backgroundImage={BG}
        backgroundSize="cover"
        backgroundPosition="center"
        backgroundColor="#74BF00E5"
        backgroundRepeat="no-repeat"
      >
        <Flex p={10} flex={1} direction="column" backgroundColor="#74BF00E5">
          <Image
            boxSize="fit-content"
            src={Amipass}
            alt="amipass"
            marginBottom={{ base: 35, sm: 35, md: 0 }}
          />
          <Flex justifyContent="center" alignItems="center" flex={1}>
            <Box position="relative" py={'100px'} px={'45px'}>
              <div className="passwordL end" />
              <div className="passwordL start" />
              <Text fontSize="xl" color="#FFFFFF">
                Bienvenido a tu portal de empresas.
              </Text>
            </Box>
          </Flex>
        </Flex>
      </Flex>
      <Flex
        flex={1.5}
        backgroundColor={'#eff1eb'}
        height={'100%'}
        overflowY={{ base: 'none', sm: 'none', md: 'auto' }}
      >
        <Flex flex={1} direction="column">
          <Flex
            py={5}
            px={10}
            alignItems="center"
            justifyContent="space-between"
            backgroundColor={{
              base: '#ffffff',
              sm: '#ffffff',
              md: 'transparent',
            }}
            display={step > 1 && step < 1 ? 'flex' : 'none'}
          >
            <Box>
              <Button
                variant="link"
                color="#565656"
                fontWeight="normal"
                onClick={handlerPreviewStep}
              >
                <FontAwesomeIcon icon={faChevronLeft} />
                <Text ms={3} color="#565656" fontWeight="normal">
                  Atrás
                </Text>
              </Button>
            </Box>
            <Box>
              <Text color="#565656" fontWeight="normal">
                Administrador de beneficio
              </Text>
              <Text textAlign="end">
                {`Paso ${steps[step]}/${steps.length - 2}`}
              </Text>
            </Box>
          </Flex>
          <Flex px={10} py={10}>
            {renderStep()}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}
